<template>
    <div class="logistics-info">
        <a-breadcrumb separator=">">
            <a-breadcrumb-item>
                <router-link to="/query-service">
                    <img :src="require('@/assets/home/报告查询.svg')" style="margin: 0 4px 4px 0" />查询服务
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
                <router-link to="/query-service">委托查询</router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>物流信息</a-breadcrumb-item>
        </a-breadcrumb>

        <div class="logistics-info-body">
            <div class="logistics-item">
                <div class="item-title">物流信息</div>
                <div class="item-content">
                    <div class="company-info">
                        <img :src="require('@/assets/home/avatar.svg')" alt="" />
                        <strong>EMS</strong>
                        <span>EMS4583204756323</span>
                    </div>

                    <div class="logistics-process">
                        <a-steps progress-dot direction="vertical">
                            <a-step
                                title="已签收 2023-12-04 15:39:40"
                                description="This is a description. This is a description."
                            />
                            <a-step title="Finished" description="This is a description. This is a description." />
                            <a-step title="In Progress" description="This is a description. This is a description." />
                            <a-step title="Waiting" description="This is a description." />
                            <a-step title="Waiting" description="This is a description." />
                        </a-steps>
                        <a>展开详情 <a-icon type="down" /></a>
                    </div>
                </div>
            </div>
            <div class="logistics-item">
                <div class="item-title">地址信息</div>
                <div class="item-content">
                    <custom-form :option="formOption" :fieldsValue="fieldsValue" />

                    <custom-form :option="formOption1" :fieldsValue="fieldsValue1" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import customForm from '../../../components/custom-form.vue';

export default {
    components: {
        customForm
    },
    data() {
        return {
            formOption: {
                id: 'receive',
                gutter: 0,
                title: '收报告地址',
                readonly: true,
                fieldGroup: [
                    [
                        {
                            label: '姓名',
                            field: 'name',
                            span: 12,
                            labelCol: { span: 6 },
                            wrapperCol: { span: 18 }
                        }
                    ],
                    [
                        {
                            label: '电话',
                            field: 'phone',
                            span: 12,
                            labelCol: { span: 6 },
                            wrapperCol: { span: 18 }
                        }
                    ],
                    [
                        {
                            label: '收报告地址',
                            field: 'address',
                            span: 12,
                            labelCol: { span: 6 },
                            wrapperCol: { span: 18 }
                        }
                    ]
                ]
            },

            fieldsValue: {
                name: '李生',
                phone: '1376483202',
                address: '北京市海淀区西四环北路119号A座3层309室'
            },

            formOption1: {
                id: 'send',
                gutter: 0,
                title: '寄货地址',
                readonly: true,
                fieldGroup: [
                    [
                        {
                            label: '姓名',
                            field: 'name',
                            span: 12,
                            labelCol: { span: 6 },
                            wrapperCol: { span: 18 }
                        }
                    ],
                    [
                        {
                            label: '电话',
                            field: 'phone',
                            span: 12,
                            labelCol: { span: 6 },
                            wrapperCol: { span: 18 }
                        }
                    ],
                    [
                        {
                            label: '寄货地址',
                            field: 'address',
                            span: 12,
                            labelCol: { span: 6 },
                            wrapperCol: { span: 18 }
                        }
                    ]
                ]
            },

            fieldsValue1: {
                name: '李生',
                phone: '1376483202',
                address: '北京市海淀区西四环北路119号A座3层309室'
            }
        };
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.logistics-info {
    width: 1200px;
    margin: 0 auto;

    &-body {
        .logistics-item {
            margin-bottom: 16px;
            background: #ffffff;
            box-shadow: 0px 2px 4px 0px rgba(13, 24, 41, 0.05);
            border-radius: 2px;

            .item-title {
                position: relative;
                opacity: 0.97;
                background: #deefff;
                border-radius: 2px 2px 0px 0px;
                height: 40px;
                line-height: 40px;
                padding-left: 24px;
                font-size: 14px;
                color: #333333;
                font-weight: 600;

                &::before {
                    width: 3px;
                    height: 12px;
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #005299;
                }
            }

            .item-content {
                padding: 16px;

                .company-info {
                    height: 56px;
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    color: #333333;
                    line-height: 32px;
                    border-bottom: 1px solid #e2e2e2;
                    margin-bottom: 25px;

                    img {
                        border-radius: 50%;
                        width: 32px;
                        height: 32px;
                        border: 1px solid rgba(238, 238, 238, 1);
                    }

                    > strong {
                        margin: 0 8px;
                    }
                }

                .logistics-process {
                    padding: 0 48px 0 40px;
                }

                :deep(.custom-form) {
                    margin-bottom: 16px;
                    background-color: #fbfcff;
                    .title {
                        height: 40px;
                        line-height: 40px;
                        padding-left: 16px;
                        border-bottom: 1px solid #e2e2e2;
                    }
                }

                :deep(.ant-steps) {
                    .ant-steps-item-icon {
                        width: 8px;
                        height: 8px;
                        border: none;
                    }

                    .ant-steps-item-content {
                        width: auto;
                    }

                    .ant-steps-item-process {
                        .ant-steps-item-icon {
                            .ant-steps-icon {
                                background: #005299;
                                border: 0 none;
                                box-shadow: none;

                                .ant-steps-icon-dot {
                                    background: #005299;
                                }
                            }
                        }
                    }

                    .ant-steps-item-wait {
                        .ant-steps-item-icon {
                            .ant-steps-icon {
                                border: 0 none;
                                box-shadow: none;
                            }
                        }
                    }

                    .ant-steps-item {
                        > .ant-steps-item-container {
                            > .ant-steps-item-tail {
                                top: 2px;
                                left: -9px;
                                margin: 0;
                                padding: 22px 0 4px;

                                &::after {
                                    height: 100%;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
